// extracted by mini-css-extract-plugin
export default {"teamSelect":"TeamSelect_teamSelect__orzo+"};